import { PaymentProfileStatus } from '../../models';

export enum PaymentProfileActions {
  PREVIEW = 'PREVIEW',
  DELETE = 'DELETE',
  USE_FOR_SUBSCRIPTION_BILLING = 'USE_FOR_SUBSCRIPTION_BILLING',
}

export const usePaymentProfileAvailableActions = (
  status: PaymentProfileStatus
): PaymentProfileActions[] => {
  const availableActions: PaymentProfileActions[] = [
    PaymentProfileActions.PREVIEW,
    PaymentProfileActions.DELETE,
  ];

  if (status === PaymentProfileStatus.NORMAL) {
    return [
      PaymentProfileActions.USE_FOR_SUBSCRIPTION_BILLING,
      ...availableActions,
    ];
  }

  return availableActions;
};
